import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scanTypes: ["VSID"],
    specialOrderStatuses: ["NEW","ORDER PLACED","ARRIVED","COLLECTED","REFUNDED"],
    locations: [],
    id: null,
    user: null,
    GLOBALS: [],
    perms: null,
    endpoint: null,
    workingId: null,
    globalQueryBc: true,
    userCache: [],
    scanBus: {
      data: null,
      type: null,
      locked: false,
    },
    isManaged: null,
    menuItems: [
      { icon: 'mdi-home', text: 'Job Calendar', path: '/', protected: false, filterIdentifier: "JOBCALENDER"},
      { icon: 'mdi-calendar-week', text: 'Appointment Calendar', path: '/appointmentCalendar', protected: false, filterIdentifier: "APPOINTMENTCALENDER"},
      { icon: 'mdi-calendar-clock-outline', text: 'Appointments', path: '/appointments' , protected: false, filterIdentifier: "APPOINTMENTS"},
      { icon: 'mdi-table-large', text: 'Jobs', path: '/jobs' , protected: false, filterIdentifier: "JOBS"},
      { icon: 'mdi-sitemap', text: 'Items', path: '/items' , protected: false, filterIdentifier: "ITEMS"},
      { icon: 'mdi-account', text: 'Customers', path: '/customers' , protected: false, filterIdentifier: "CUSTOMERS"},
      { icon: 'mdi-account-multiple', text: 'User Management', path: '/users' , protected: true, filterIdentifier: "USERMANAGEMENT"},
      { icon: 'mdi-content-cut', text: 'Tailors', path: '/tailors' , protected: false, filterIdentifier: "TAILORS"},
      { icon: 'mdi-account-group', text: 'Events', path: '/events' , protected: false, filterIdentifier: "EVENTS"},
      { icon: 'mdi-finance', text: 'Reporting', path: '/reporting', protected: true, filterIdentifier: "REPORTING"},
      { icon: 'mdi-star-circle-outline', text: 'Special Orders', path: '/specialOrders', protected: true, filterIdentifier: "ITEMS"},
      { icon: 'mdi-warehouse', text: 'Suppliers', path: '/suppliers', protected: true, filterIdentifier: "ITEMS"},
      { icon: 'mdi-devices', text: 'Devices', path: '/devices', protected: true, filterIdentifier: "DEVICES"},
      { icon: 'mdi-store', text: 'Locations', path: '/locations', protected: false, filterIdentifier: 'LOCATION'},
      { icon: 'mdi-graphql', text: 'Super Admin', path: '/superAdmin', protected: true, filterIdentifier: "SUPER"}
    ],

  },
  mutations: {
    setUser(state, user){
      localStorage.setItem('id', user.id)
      state.user = user
      state.id = user.id
    },
    setUserCache(state, users){
      state.userCache = users
      console.log(state.userCache.length > 0 ? "VUEX: ✅ User Cache loaded." : "VUEX: ❌ User Cache not loaded.")
    },
    setLocations(state, locations){
      state.locations = locations
      console.log(state.locations ? "VUEX: ✅ Locations loaded." : "VUEX: ❌ Locations not loaded.")
    },
    clearUserCache(state){
      state.userCache = []
    },
    async loadPerms(state){
      try{
        let perms = await axios.get(`${state.endpoint}/getPerms`)
        if(perms.data.error) throw "Error fetching permission data."
        state.perms = perms.data;
      }
      catch (e) {
        console.error(e);
      }
    },
    setPerms(state, perms){
      state.perms = perms;
    },
    setEndpoint(state, endpoint){
      state.endpoint = endpoint;
    },
    updateWorkingId(state, wId){
      localStorage.setItem('workingId', wId)
      state.workingId = wId;
    },
    deleteWorkingId(state){
      localStorage.removeItem('workingId')
      state.workingId = null;
    },
    lockGlobalQueryBc(state){
      state.globalQueryBc = false
      console.log("Global Barcode Listener Locked")
    },
    unlockGlobalQueryBc(state){
      state.globalQueryBc = true
      console.log("Global Barcode Listener Unlocked")
    },
    initialiseStore(state) {
      if (localStorage.getItem('id')) {
        state.id = localStorage.getItem('id');
        state.workingId = localStorage.getItem('workingId');
      }
    },
    logout(state){
      localStorage.removeItem('id')
      localStorage.setItem('workingId', null)
      state.id = null;
      state.workingId = null;
      state.perms = null;
      state.user = null
    },
    removeIds(state){
      state.id = null;
      state.userName = null;
      state.user = null
    },
    setScanBusData(state, data){
      if(data){
        state.scanBus.data = data
      }
    },
    setScanBusType(state, type){
      if(type)
        state.scanBus.type = type
    },
    resetScanBus(state){
      state.scanBus.type = null
      state.scanBus.data = null
    },
    lockScanBus(state,type){
      state.scanBus.locked = true
      state.scanBus.type = type
      console.log("Scan Bus Locked")
    },
    unlockScanBus(state, prev=null){
      if(prev){
        state.scanBus=prev
        console.log("Scan Bus Returned to Previous State")
      }else{
        state.scanBus.locked = false
        state.scanBus.type = null
        console.log("Scan Bus Unlocked")
      }
    },
    setManaged(state, val){
      state.isManaged = val;
    },
    setGLOBALS(state, val){
      state.GLOBALS = val;
      console.log("VUEX: ✅ DB Globals Set.")
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    getId: state => state.id,
    getEndpoint: state => state.endpoint,
    getWorkingId: state => state.workingId,
    getPerms: state => state.perms,
    getUserCache: state => state.userCache,
    menuItems: (state) => {
      let allowedMenuItems = state.GLOBALS.find(x=>x.key=="VEC_MENU_ITEMS")?.value.split("\n")
      if(!allowedMenuItems) return
      let x = state.menuItems.filter(x=>(allowedMenuItems.find(y=>y==x.filterIdentifier)!=undefined) && state?.perms?.permissions.allowedMenuItems[x.filterIdentifier]==true)
      return x
    },
    lookupUsername: (state) => (id) =>{
      if(!id) return null
      let y = state.userCache.find(x=>x.id==id)
      if(!y) return null
      return y.firstName + ' ' + y.lastName
    },
    getUser: state => state.user,
    isLoggedIn: state => state.id ? true : false,
    globalQueryBcAllowed: (state)=>{
      return state.globalQueryBc
    },
    isAllowed: (state) => (resource, requiredPerm) => {
      if(!resource) return false
      if(!requiredPerm) return false
      if(!state.perms) return false
      return (state.perms.permissions[resource])[requiredPerm]
    },
    getRole: state => state.perms?.description,
    nowServing: state => state.sIDAuthorizer.nowServing,
    scanBus: state => state.scanBus,
    isManaged: state => state.isManaged,
    getGlobalValue: (state) => (key) => (state.GLOBALS.find(x=>x.key==key))?.value,
    specialOrderStatuses: state => state.specialOrderStatuses,
    getLocation: (state) => (id) =>{
      if(!id) return null
      let y = state.locations.find(x=>x.id==id)
      if(!y) return null
      return y;
    },
    getLocations: state => state.locations,
    lookupLocation: (state) => (id) =>{
      if(!id) return null
      let y = state.locations.find(x=>x.id==id)
      if(!y) return null
      return y.name;
    },
    lookupLocationIcon: (state) => (id) =>{
      if(!id) return null
      let y = state.locations.find(x=>x.id==id)
      if(!y) return null
      if(y.metadata.icon) return y.metadata.icon;
      if(y.metadata.shortName) return y.metadata.shortName;
      return y.name;
    },
  }
})
